
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class UpdateAlert extends Vue {
  @Prop() public value!: string;
  private refresh() {
    window.location.reload();
  }
}
